/**
 * Fusion PURE des deux sources d'un fil de discussion : les messages
 * asynchrones (`discussion_messages`) et ceux des salles visio qui lui ont été
 * rattachées (`visio_room_messages` de tout `video_rooms` où `discussion_id`
 * correspond). C'est ici — côté client, sans aucune vue ni RPC de lecture
 * unifiée — que se joue l'« unification » : le chat visio existant reste
 * intact, cette fonction ne fait que les mélanger à l'affichage.
 */

import type {
  DiscussionTimelineMessage,
  RawDiscussionMessageRow,
  RawRoomMessageRow,
} from './types';

export function mergeDiscussionTimeline(
  discussionMessages: readonly RawDiscussionMessageRow[],
  roomMessages: readonly RawRoomMessageRow[],
): DiscussionTimelineMessage[] {
  const fromDiscussion: DiscussionTimelineMessage[] = discussionMessages.map((m) => ({
    id: `disc:${m.id}`,
    rawId: m.id,
    origin: 'discussion',
    roomId: null,
    senderId: m.sender_id,
    body: m.body,
    source: m.source,
    documentId: m.document_id,
    hiddenAt: m.hidden_at,
    createdAt: m.created_at,
  }));

  const fromRoom: DiscussionTimelineMessage[] = roomMessages.map((m) => ({
    id: `room:${m.id}`,
    rawId: m.id,
    origin: 'room',
    roomId: m.room_id,
    senderId: m.sender_id,
    body: m.body,
    source: m.source,
    documentId: m.document_id,
    hiddenAt: m.hidden_at,
    createdAt: m.created_at,
  }));

  return [...fromDiscussion, ...fromRoom].sort((a, b) => a.createdAt.localeCompare(b.createdAt));
}
